import React from "react";
import styles from "./ConstructionBody.module.scss";

import ConstructionTable from "../table/ConstructionTable";
import ConstructionTableCollapsible from "../collapsible/ConstructionTableCollapsible";
import {type ConstructionBodyBlockProps, type ConstructionBodyProps, exceptionParts} from "./ConstructionBodyProps";
import ConstructionStatus from "../../../../types/ConstructionStatus";

const ConstructionBody: React.FC<ConstructionBodyProps> = ({construction}) => {
  const parts = construction.constructionParts;
  const keys = Object.keys(parts) as Array<keyof typeof parts>;

  return (
    <div className={styles.constructionBodyContainer}>
      {keys.map((key, i) => (
        <ConstructionBodyBlock
          constructionId={construction.id}
          key={i}
          constructionPart={parts[key]}
          name={key}
          isAccepted={construction.status === ConstructionStatus.Accepted}
        />
      ))}
    </div>
  );
};

const ConstructionBodyBlock: React.FC<ConstructionBodyBlockProps> = ({
  constructionId,
  name,
  constructionPart,
  isAccepted,
}) => {
  if (exceptionParts.includes(name)) {
    return null;
  }

  const isCollapsible = (constructionElementsName: string): boolean =>
    !["location", "metadata", "specification", "calculationParameters"].includes(constructionElementsName);

  const keys = Object.keys(constructionPart) as Array<keyof typeof constructionPart>;

  return (
    <div className={styles.constructionBodyBlock}>
      {keys.map((key, _) => {
        const partItems = constructionPart[key];

        return isCollapsible(key) ? (
          <ConstructionTableCollapsible key={key} count={(partItems as unknown[]).length} name={key}>
            <ConstructionTable
              constructionId={constructionId}
              constructionElementsName={key}
              constructionPartItems={partItems}
              isAccepted={isAccepted}
            />
          </ConstructionTableCollapsible>
        ) : (
          <ConstructionTable
            key={key}
            constructionId={constructionId}
            constructionElementsName={key}
            constructionPartItems={partItems}
            isAccepted={isAccepted}
          />
        );
      })}
    </div>
  );
};

export default ConstructionBody;
